import {Injectable, signal} from '@angular/core';

/**
 * Integration keys active for the vehicle currently open, published by the
 * vehicle form page from its one-click platform statuses.
 *
 * BRIEFD-7359: `IntegrationService.getIntegrations()` called without a
 * `businessUnitUuid` returns only the ACCOUNT-scoped integrations — Njuškalo,
 * Bolha, Index.hr and Shopaj24 are `per_business_unit`, so they are missing from
 * it entirely. The portal-usage indicator read that list and therefore claimed
 * a dealer with all four connected used none of them. The platform statuses the
 * form already fetches are resolved server-side against the vehicle's own
 * business unit, which is the answer the indicator actually wants.
 *
 * Each portal carries the market it publishes into, as the API already resolves
 * it (`PlatformStatusDto::country` → `AdFieldsHelper::marketCountry()`), so the
 * flag-scoped indicator does not have to consult the frontend's own copy of that
 * table here. Null country = the portal is bound to no market of its own.
 *
 * Null means "no vehicle context" (settings forms, the vehicle detail page) —
 * consumers fall back to the account-level integrations list there.
 */
export interface ActivePortal {
  key: string;
  country: string | null;
}

@Injectable({providedIn: 'root'})
export class ActivePortalsService {
  readonly active = signal<ActivePortal[] | null>(null);

  set(portals: ActivePortal[] | null): void {
    this.active.set(portals?.map((p) => ({key: p.key.toLowerCase(), country: p.country?.toLowerCase() ?? null})) ?? null);
  }
}
